import React, { useState, useEffect } from "react"
import { Container, Row, Col, Spinner } from "reactstrap"
import moment from "moment"
// import html2canvas from "html2canvas"
// import AvibraHeader from "../AlertDetail/AvibraHeader"
// import AvibraSubHeader from "../AlertDetail/AvibraSubHeader"
// import AvibraFooter from "../AlertDetail/AvibraFooter"
import MembershipGuide from "./MembershipGuide"
import GoogleTranslate from "../GoogleTranslate"
import {
  initializeAWSToken,
  getUserProfile,
  getPolicyDetailsApi,
  getBeneficiaryApi,
  getInsurancePageApi,
  getAnalyticScoreApi,
  getFeparamsApi,
  getAccidentalInsurance,
  getMembershipDetailsApi,
  getExternalProfileExist,
  getSubscriptionMatrixApi,

  getAddons,
  getDobsPurchases,
  getPdfProductProviders,
  GetDollarClubCardDetails,
  getDobsPartnerConfigs,
  getPartnerKeyByProfileId
} from "../../api/policyDocumentApi"
import { AppConfig } from "../../../constant/constant"
import logo from "../../../images/icon-cobranding.png"
import "../../../styles/AlertDetail/alert-detail.css"
import "../../../styles/AlertDetail/alert-detail-responsiveness.css"
import "../../../styles/Membership/membership.css"
import html2pdf from "html2pdf.js"
import { setLogEvent, setAmplitudeInit, getUserPlans, filterByKeys, sortPlans, parsePlanMeta } from "../../utils/helpers"
import NewMembershipGuide from "./NewMembershipGuide";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useNavigate,useParams } from 'react-router'; 

const MemberShip = props => {

  let params = useParams();
  const [loading, setLoading] = useState(true)
  const [policy, setPolicy] = useState({})
  const [beneficiary, setBeneficiary] = useState([])
  const [insurance, setInsurance] = useState([])
  const [userInfo, setUserInfo] = useState('')
  const [wellbeing, setWellbeing] = useState({})
  const [isDollarStore, setIsDollarStore] = useState('')
  const [risk, setRisk] = useState({})
  const [plusPlanDetails, setPlusPlanDetails] = useState([])
  //const { match = {} } = props
  //const { params = {} } = match
  const { membershipToken = "" } = params
  let decodedTokenString = atob(membershipToken)
  let decodedToken = JSON.parse(decodedTokenString)
  let { profileid = "", signuptype = "", token = "",lang='' } = decodedToken
  const [loadingPdf, setLoadingPdf] = useState(false)
  const [waitingPeriod, setWaitingPeriod] = useState("")
  const [insuranceDisclaimer, setInsuranceDisclaimer] = useState("")
  const [accidentalInsurance, setAccidentalInsurance] = useState({})
  const [purchasedDobsPlan, setPurchasedDobsPlan] = useState([])
  const [addonsPlanList, setAddonsPlanList] = useState([])
  
  const [membershipState, setUserMembershipState] = useState("Inactive")
  const [subscriptionMatrixData, setSubscriptionMatrixData] = useState([])
  const [insuranceCoverage, setInsuranceCoverage] = useState()
  const [dynamicPdfFileName, setDynamicPdfFileName] = useState('')
  const [lifeadndInsuranceProvider, setLifeAdndInsuranceProvider] = useState('')
  const [dollarCludData, setDollarCludData] = useState({})
  const [hideDollarBenefitsDetailsSlides, setHideDollarBenefitsDetailsSlides] = useState(false)

  console.log("purchasedDobsPlan==>", purchasedDobsPlan)

  useEffect(() => {
    if (profileid) {
      setInsurance(JSON.parse(AppConfig.insurancecoveragetable))
      getFeparamsApi()
        .then(res => {
          let { data = {} } = res
          let { plusplandetails = [], waitingperiod = "", amplitudeKey = "", insurancedisclamer } = data
          setInsuranceDisclaimer(insurancedisclamer)
          setAmplitudeInit(amplitudeKey)
          setWaitingPeriod(waitingperiod)
          setPlusPlanDetails(JSON.parse(plusplandetails))
          // getMembershipDetailsApi().then(res => {
          //   console.log(res, 'this')
          // }).catch(_ => setLoading(false))

          initializeAWSToken(token, signuptype)
            .then(() => {
              window.isAwsSignatureSet = true;
              getPartnerKeyByProfileId(profileid, token).then(resPartKey => {
                console.log("getPartnerKeyByProfileId 2 ==>", resPartKey);
                const partnerkey = resPartKey?.data ? resPartKey?.data : '';
                if(partnerkey){
                  getDobsPartnerConfigs(partnerkey).then(resData => {
                    const {partnerWebRegistrationConfig={}} = resData?.data ? resData?.data : {};
                    const {hideDobsOnMembershipGuide=false} = partnerWebRegistrationConfig ? partnerWebRegistrationConfig : {};
                    console.log("getDobsPartnerConfigs partnerWebRegistrationConfig ==>", partnerWebRegistrationConfig);
                    setHideDollarBenefitsDetailsSlides(hideDobsOnMembershipGuide);
                  }).catch((err) => console.log("getDobsPartnerConfigs error:",err))
                }
              }).catch((err) => console.log("getDobsPartnerConfigs error:",err))
              getDobsPurchases(profileid).then(res => {
                let { data } = res 
                console.log("res of purchased dollar", res)
                setPurchasedDobsPlan(data)
                //setLoading(false)
              }).catch(_ => setLoading(false))
    
              getPdfProductProviders(profileid).then(res => {
                let { data } = res 
                console.log("getPdfProductProviders of res", data)
                const {lifeProvider = '', adndProvider = ''} = data;
                if(lifeProvider && adndProvider){
                  let pdfFileName = `Avibra_Products_${lifeProvider}_${adndProvider}.pdf`
                  setDynamicPdfFileName(pdfFileName)
                  setLifeAdndInsuranceProvider(`${lifeProvider}_${adndProvider}`);
                }
              }).catch((err) =>{ 
                  console.log("getPdfProductProviders of Error", err);
              })

              getAddons(profileid).then(res => {
                let { data } = res 
                setAddonsPlanList(data)
                //setLoading(false)
              }).catch(_ => setLoading(false))

              getSubscriptionMatrixApi(profileid).then(res => {
                let { data } = res 
                //console.log("SubscriptionMatrix Res Data---->", data);
                /*let data1 = {{"feature":"price","core":"Free","grow":"$5.99/mo"},{"feature":"plandetails","core":"{\"planName\":\"Core\",\"pricing\":\"Free\",\"buttonName\":\"Core (Free)\",\"levels\":\"\"}","grow":"{\"planName\":\"Grow\",\"pricing\":\"$5.99/mo\",\"buttonName\":\"Grow ($5.99/mo)\",\"levels\":\"grow_level1,grow_annual_level1\"}"},{"displayName":"Life Insurance","feature":"life","description":"The maximum life insurance coverage is the amount you can earn through your good habits. The money earned provides a lump sum payment to your beneficiaries upon your death.","icon":"https://lifexartifactbucket.s3.amazonaws.com/icons/tip.png","grow":"$3K","core":"$3K"},{"displayName":"Accidental Death Insurance","feature":"adnd","description":"Accidental death and dismemberment (AD&D) covers the unintentional death or dismemberment of an insured person. Typically, accidental death covers exceptional circumstances, such as exposure to the elements, traffic accidents, homicide, falls, drowning, and accidents involving heavy equipment. Generally, the AD&D policy also pays a percentage for the loss of a limb, partial or permanent paralysis, or the loss of use of specific body parts, such as the loss of sight, hearing, or speech.","icon":"https://lifexartifactbucket.s3.amazonaws.com/icons/bank.png","grow":"$5K","core":"$5K"},{"displayName":"myRisk 360","feature":"myRisk","description":"myRisk 360 is a real time risk advisor to help you be more aware of the risks to you and the people and things you love.","icon":"https://lifexartifactbucket.s3.amazonaws.com/icons/tip.png","grow":"Y","core":"N"},{"displayName":"myLocation","feature":"myLocation","description":"myLocation identifies risks that are based on your location to help you understand more about where you live, work and travel or vacation.","icon":"https://lifexartifactbucket.s3.amazonaws.com/icons/tip.png","grow":"Y","core":"N"},{"displayName":"myRadar","feature":"myRadar","description":"myRadar alerts you in advance of possible events or threats that could lead to bigger risks for you and your loved ones.","icon":"https://lifexartifactbucket.s3.amazonaws.com/icons/tip.png","grow":"Y","core":"N"},{"displayName":"myDwelling","feature":"myDwelling","description":"myDwelling - a complete risk profile for where you live or rent and figure out ways to take extra precautions to protect you and your loved ones.","icon":"https://lifexartifactbucket.s3.amazonaws.com/icons/tip.png","grow":"Y","core":"N"},{"displayName":"myHealth","feature":"myHealth","description":"myHealth - Learn about the likely health risks you may be facing now and in the future based on factors such as your age and habits. Improve your health score and turn your good habits into insurance coverage by engaging with in-app activities.","icon":"https://lifexartifactbucket.s3.amazonaws.com/icons/tip.png","grow":"Y","core":"N"},{"displayName":"myRide","feature":"myRide","description":"","icon":"","grow":"Y","core":"N"},{"displayName":"myGuardian","feature":"myGuardian","description":"","icon":"","grow":"Y","core":"N"},{"displayName":"Waived App Activity Requirements","feature":"waive","description":"Core members can keep their benefits active by staying active in the app. That means not just logging in, but completing at least one task in the app, such as reading an article, watching a video or finishing a quiz at least once a month. This step is not required to maintain benefits for Plus Members.","icon":"https://icons.avibra.com/checkin.png","grow":"Y","core":"N"},{"displayName":"myGrowth 360","feature":"myGrowth","description":"myGrowth 360 is your complete well-being advisor, with the goal of making you a better version of yourself.","icon":"https://lifexartifactbucket.s3.amazonaws.com/icons/tip.png","grow":"Y","core":"Y"},{"displayName":"10 Tips Series","feature":"10tips","description":"Our 10 Tips articles are quick reads that help you improve your health, relationships and finances.","icon":"https://lifexartifactbucket.s3.amazonaws.com/icons/tip.png","grow":"Y","core":"Y"},{"displayName":"Social Impact","feature":"socialimpact","description":"Learn about the social issues individuals and communities face ⁠— and what steps we can take to tackle them head on. Plus, we’ll donate to an organization that’s aligned with each month’s cause.","icon":"https://lifexartifactbucket.s3.amazonaws.com/icons/group.png","grow":"Y","core":"Y"},{"displayName":"Guided Meditation","feature":"meditation","description":"Improve your mental and physical health through our guided meditations.","icon":"https://lifexartifactbucket.s3.amazonaws.com/icons/meditation.png","grow":"Y","core":"Y"}}*/
                setSubscriptionMatrixData(data);
              }).catch(_ => setLoading(false))
    
              GetDollarClubCardDetails(profileid).then((res)=>{
                console.log('res GetDollarClubCardDetails', res)
                setDollarCludData(res.data)
              }).catch((err)=>{
                console.log('err', err)
              })

              getAnalyticScoreApi(profileid)
                .then(res => {
                  let { data = {} } = res
                  let { wellbeing, risk } = data
                  setWellbeing(wellbeing)
                  setRisk(risk)
                  getPolicyDetailsApi(profileid)
                    .then(res => {
                      let { data = [] } = res
                      setPolicy(data[0])
                      getBeneficiaryApi({ profileId: profileid })
                        .then(res => {
                          let { data = [] } = res
                          setLogEvent("Total Beneficiary", {
                            count: data.length
                          })
                          setBeneficiary(data)
                          getUserProfile(profileid)
                            .then(res => {
                              let { data = {} } = res
                              setUserInfo(data)
                              getExternalProfileExist({
                                "identity": data.usercode
                              })
                              .then(res => {
                                const existData = res.data
                                setUserMembershipState(existData.state)
                                setInsuranceCoverage(existData.productcoverages)
                                setIsDollarStore(existData.isdollarstore)
                              }).catch((err) => {
                                setIsDollarStore(false)
                              })                

                              //setUserInfo(data)
                              let payload = { "profileid": profileid }
                              getAccidentalInsurance(payload).then(res => {
                                let { data } = res 
                                setAccidentalInsurance(data[0])
                                setLoading(false)
                              }).catch(_ => setLoading(false))
                            })
                            .catch((err) => {
                              setIsDollarStore(true)
                              setLoading(false)
                            })
                        })
                        .catch(_ => setLoading(false))
                    })
                    .catch((err) => {
                      setIsDollarStore(true)
                      setLoading(false)
                    })
                })
                .catch(_ => setLoading(false))
            })
            .catch(_ => setLoading(false))
        })
        .catch(_ => setLoading(false))
    }
  }, [])

  function insertAfter(el, referenceNode) {
    referenceNode.parentNode.insertBefore(el, referenceNode.nextSibling)
  }

  const onClickSave = async () => {
    window.scroll(0, 0)
    setLoadingPdf(true)
    let quotes = document.getElementById("print-pdf")
    let breakSec = document.getElementById("break")
    let membership2 = document.getElementById("membership2")
    let sidebar = document.getElementById("membership1")
    let membershipInfo = document.getElementById("membership-info")
    let screenSize = window.matchMedia("(max-width: 768px)")
    let logoPrint = document.getElementById("logo-print")
    logoPrint.style.display = "block"
    membershipInfo.style.boxShadow = "none"
    membershipInfo.style.width = "100%"
    membershipInfo.style.maxWidth = "none"
    membership2.prepend(sidebar)
    let shareAndCare = document.getElementById("share-and-care")
    let mainSide = document.getElementById("main-side")
    let myRiskChart = document.getElementById("my-risk-chart")
    let wellBeingChart = document.getElementById("well-being-chart")
    shareAndCare.style.boxShadow = "none"
    myRiskChart.style.boxShadow = "none"
    wellBeingChart.style.boxShadow = "none"
    //quotes.style.lineHeight = screenSize.matches ? "unset" : "21.2999999999px"
    // console.log(quotes, 'quotes')
    // setLoadingPdf(false)
    // return
    var opt = {
      margin: screenSize.matches ? [10, 10] : [15, 15],
      filename: `AvibraPolicyDocument-${moment().valueOf()}`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 1, letterRendering: true  },
      jsPDF:        { unit: 'pt', format: 'letter', orientation: 'portrait' },
      pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
    }
    var worker = new html2pdf()
    await worker
      .set(opt)
      .from(quotes)
      .save()
      .then(_ => {
        logoPrint.style.display = "none"
        shareAndCare.style.boxShadow = "0 2px 6px 0 rgba(57, 73, 96, 0.2)"
        myRiskChart.style.boxShadow = "0 2px 6px 0 rgba(57, 73, 96, 0.2)"
        wellBeingChart.style.boxShadow = "0 2px 6px 0 rgba(57, 73, 96, 0.2)"
        membershipInfo.style.boxShadow = "0 2px 6px 0 rgba(57, 73, 96, 0.2)"
        membershipInfo.style.width = "100%"
        membershipInfo.style.maxWidth = "340px"
        //quotes.style.lineHeight = "unset"
        let elements = membership2.getElementsByTagName("section")
        quotes.style.lineHeight = "unset"
        insertAfter(elements[0], mainSide)
        setLoadingPdf(false)
      })
  }
  //const plusplanHeader = filterByKeys(subscriptionMatrixData.slice(0,1)[0], userInfo.productids ? getUserPlans(userInfo.productids) : ["core","plus"]);
  //const plusplandetails_slice = subscriptionMatrixData.slice(1);
  //const userPlans = sortPlans({...plusplanHeader});
  let plusplanHeader = {};
  let planMeta = {};
  let plusplandetails_slice =  [];
  let userPlans = {}
  if(subscriptionMatrixData.length){
    plusplanHeader = subscriptionMatrixData.slice(0,2)[0];
    planMeta = parsePlanMeta(subscriptionMatrixData.slice(0,2)[1]);
    plusplandetails_slice = subscriptionMatrixData.slice(2);
    if(plusplanHeader.feature)
      delete plusplanHeader.feature
    userPlans = sortPlans({...plusplanHeader});
  }
  if (profileid) {
    return (
      <Container fluid>
        {!loading ? (
          <React.Fragment>
            <Helmet>
                <title>Membership Document</title>
                <meta name="description" content={''} />
                <meta name="keywords" content={''} />
                <meta name="viewport" content="width=device-width, initial-scale=0.3, maximum-scale=5.0, minimum-scale=0.3"/>
            </Helmet>
            <Row>
              <Col>
                {/* <AvibraHeader /> */}
                {(lang && lang != 'en') ? <GoogleTranslate langCode={lang}/> : null}
              </Col>
            </Row>
            <Row>
              <Col className="padding-none">{/* <AvibraSubHeader /> */}</Col>
            </Row>
            <Row>
              <Col className="padding-none membership-guide-document">
                {
                (isDollarStore === false) ? <MembershipGuide
                  policy={policy}
                  beneficiary={beneficiary}
                  wellbeing={wellbeing}
                  risk={risk}
                  plusPlanDetails={plusplandetails_slice}
                  plusplanHeader={plusplanHeader}
                  userPlans={userPlans}
                  planMeta={planMeta}
                  userInfo={userInfo}
                  onClickSave={onClickSave}
                  insurance={insurance}
                  waitingPeriod={waitingPeriod}
                  insuranceDisclaimer={insuranceDisclaimer}
                  accidentalInsurance={accidentalInsurance}
                  membershipState={membershipState}
                  insuranceCoverage={insuranceCoverage}
                  isDollarStore={isDollarStore}
                  dollarCludData={dollarCludData}
                /> : null}
                
                {(isDollarStore == true) ? 
                <NewMembershipGuide 
                  profileid={profileid}
                  purchasedDobsPlan={purchasedDobsPlan}
                  addonsPlanList={addonsPlanList}
                  policy={policy}
                  userInfo={userInfo}
                  accidentalInsurance={accidentalInsurance}
                  isDollarStore={isDollarStore}
                  membershipState={membershipState}
                  beneficiary={beneficiary}
                  onClickSave={onClickSave}
                  wellbeing={wellbeing}
                  risk={risk}
                  plusPlanDetails={plusplandetails_slice}
                  plusplanHeader={plusplanHeader}
                  userPlans={userPlans}
                  planMeta={planMeta}
                  insurance={insurance}
                  waitingPeriod={waitingPeriod}
                  insuranceDisclaimer={insuranceDisclaimer}
                  insuranceCoverage={insuranceCoverage}
                  dynamicPdfFileName={dynamicPdfFileName || ''}
                  lifeadndInsuranceProvider={lifeadndInsuranceProvider || ''}
                  dollarCludData={dollarCludData}
                  hideDollarBenefitsDetailsSlides={hideDollarBenefitsDetailsSlides}
                /> : null }
              </Col>
            </Row>
            <Row>
              <Col className="padding-none">{/* <AvibraFooter /> */}</Col>
            </Row>
          </React.Fragment>
        ) : (
          <div className="full-width loader-container">
            <Spinner style={{width:'25px',height:'25px',color:'#333'}} color={"#333"} height={25} width={25} />
          </div>
        )}
        <Row>
          <div className={`hidden-overlay ${!loadingPdf ? "hide" : ""}`}>
            <div className="full-width loader-container">
              <Spinner
                style={{width:'25px',height:'25px',color:'#333'}}
                color={"#333"}
                height={25}
                width={25}
              />
            </div>
          </div>
        </Row>
      </Container>
    )
  } else {
    return (
      <div className="text-center user-exists">
        <img src={logo} />
        <p>User doesn't exist</p>
      </div>
    )
  }
}
export default MemberShip
